const fullPageBannerClassName = 'full-page-banner-element';

/** Check if fullPageBanner conditions are fulfilled
 * @returns {boolean} True if fullPageBanner must be added, False otherwise
 */
function mustAddFullPageBanner() {
  const fullPageBannerElement = document.querySelector(
    `.${fullPageBannerClassName}`
  );
  if (fullPageBannerElement) return false;

  const cookieUtils = require('../common/utils/cookieUtils');
  if (cookieUtils.getCookie('cortinilla') === '0') return false;

  const { default: getFrontConfig } = require('../common/getFrontConfig');
  const FRONT_CONFIG = getFrontConfig();

  const fullPageBannerStartDate = new Date(
    FRONT_CONFIG.fullPageBannerStartDate
  );
  const fullPageBannerEndDate = new Date(FRONT_CONFIG.fullPageBannerEndDate);
  const dateNow = new Date();
  return fullPageBannerStartDate <= dateNow && dateNow <= fullPageBannerEndDate;
}

/** Load fullPageBanner Content Asset
 */
async function loadFullPageBanner() {
  const contentAssetUtils = require('../common/utils/contentAssetUtils');

  const fullPageBannerDiv = document.createElement('div');
  fullPageBannerDiv.classList.add(fullPageBannerClassName);
  document.body.appendChild(fullPageBannerDiv);
  document.body.style.overflow = 'hidden';

  const fullPageBannerContent =
    await contentAssetUtils.getContentAsset('fullPageBanner');
  if (fullPageBannerContent.length === 0) {
    return;
  }
  const fullPageBannerElement = document.querySelector(
    `.${fullPageBannerClassName}`
  );
  fullPageBannerElement.innerHTML = fullPageBannerContent;
}

/** fullPageBanner entry function to check & add fullPageBanner if needed
 */
function init() {
  if (mustAddFullPageBanner()) {
    loadFullPageBanner();
  }
}

module.exports = {
  init,
};
